import { HTTPS_PROTOCOL } from '../marketplace';
import { combineURLs } from './helpers';

/**
 * We separate this function from `helpers.ts` because helpers.ts may import from vite.config.ts
 * and it will show below warning since import.meta is not loaded in the Vite config file:
 * "import.meta" is not available with the "cjs" output format and will be empty [empty-import-meta]
 */
export function getFullUrl(path: string): string;
export function getFullUrl(path?: string): string | undefined;
export function getFullUrl(path?: string) {
  if (!path) return undefined;
  if (path.startsWith(HTTPS_PROTOCOL)) return path;
  return combineURLs(import.meta.env.VITE_APP_ASSET_BASE_URL, path);
}

export function getNftFallbackImage() {
  const size = 96 * Math.ceil(window.devicePixelRatio); // Hardcode 96 for now
  return combineURLs(
    import.meta.env.VITE_APP_ASSET_BASE_URL,
    `/fallback/${size > 480 ? 480 : size}.webp`
  );
}
